import { Link } from "react-router-dom";
import footerlogo from "../assets/images/footerlogo.png";

const SERVICES = [
  { label: "Modular Operation Theatres", path: "/modular-operation-theatres" },
  { label: "ICU Setup", path: "/icu-setup" },
  { label: "Dialysis Setup", path: "/dialysis-setup" },
  { label: "NABH Consultant", path: "/nabh-consultant" },
  { label: "Architects & Construction", path: "/architects-construction" },
  { label: "Medical Gases", path: "/medical-gases" },
  { label: "HVAC", path: "/hvac" },
  { label: "Biomedical Services", path: "/biomedical-service" },
];

const DESIGN_IDEAS = [
  { label: "OT Suite Designs", path: "/ot-suite-designs" },
  { label: "ICU Layout Designs", path: "/icu-layout-designs" },
  { label: "Patient Ward Designs", path: "/patient-ward-designs" },
  { label: "Nursing Station Designs", path: "/nursing-station-designs" },
];

const COMPANY = [
  { label: "About Us", path: "/about" },
  { label: "Careers", path: "/careers" },
  { label: "Terms & Conditions", path: "/terms-and-conditions" },
  { label: "Store Locator", path: "/store-locator" },
  { label: "Policies", path: "/policies" },
  { label: "Contact Us", path: "/contact-us" },
];

const SOCIALS = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61577796782877",
    icon: (
      <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
        <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.15 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.23.2 2.23.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.91h-2.33V22c4.78-.79 8.44-4.94 8.44-9.94z" />
      </svg>
    ),
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/tevahpvtltd/",
    icon: (
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="2.5" y="2.5" width="19" height="19" rx="5" />
        <circle cx="12" cy="12" r="4.2" />
        <circle cx="17.35" cy="6.65" r="1" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    label: "WhatsApp",
    href: "https://wa.me/919993999840",
    icon: (
      <svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor">
        <path d="M17.47 14.38c-.29-.15-1.71-.84-1.97-.94-.27-.1-.46-.15-.66.15-.19.29-.75.94-.92 1.13-.17.19-.34.22-.63.07-.29-.15-1.22-.45-2.33-1.44-.86-.77-1.44-1.71-1.61-2-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.66-1.59-.9-2.18-.24-.57-.48-.5-.66-.51h-.56c-.19 0-.51.07-.78.36-.27.29-1.02 1-1.02 2.44s1.04 2.83 1.19 3.03c.15.19 2.05 3.13 4.97 4.39.69.3 1.23.48 1.65.61.69.22 1.32.19 1.82.11.55-.08 1.71-.7 1.95-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.19-.55-.34z" />
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.85.5 3.58 1.38 5.07L2 22l5.19-1.47a9.9 9.9 0 0 0 4.85 1.24h.01c5.46 0 9.9-4.45 9.9-9.91C21.95 6.4 17.5 2 12.04 2zm0 18.06h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.08.87.82-3.01-.19-.31a8.15 8.15 0 0 1-1.25-4.37c0-4.51 3.68-8.19 8.21-8.19 2.19 0 4.25.86 5.8 2.4a8.13 8.13 0 0 1 2.4 5.79c0 4.51-3.68 8.14-8.21 8.14z" />
      </svg>
    ),
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/@tevahpvtltd",
    icon: (
      <svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor">
        <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-2C18.88 4 12 4 12 4s-6.88 0-8.59.42a2.78 2.78 0 0 0-1.95 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33 2.78 2.78 0 0 0 1.95 2C5.12 19.5 12 19.5 12 19.5s6.88 0 8.59-.42a2.78 2.78 0 0 0 1.95-2 29 29 0 0 0 .46-5.33 29 29 0 0 0-.46-5.33z" />
        <path d="M9.75 15.02V8.48l5.75 3.27z" fill="#343F86" />
      </svg>
    ),
  },
];

const LOCATIONS = [
 { label: "Bhuvanagiri", path: "/bhuvanagiri" },
      { label: "Hyderabad", path: "/hyderabad" },
      { label: "Indresham", path: "/indresham" },
      { label: "Jangaon", path: "/jangaon" },
      { label: "Khammam", path: "/khammam" },
      { label: "Mahabubnagar", path: "/mahabubnagar" },
      { label: "Narsapur", path: "/narsapur" },
      { label: "Rajahmundry", path: "/rajahmundry" },
      { label: "Sangareddy", path: "/sangareddy" },
      { label: "Vijayawada", path: "/vijayawada" },
];

export default function Footer() {
  return (
    <>
      <style>{`
        .tf-root {
          background: #343F86;
          color: #fff;
          font-family: 'Inter', 'Montserrat', sans-serif;
          overflow-x: hidden;
        }

        .tf-main { max-width: 1160px; margin: 0 auto; padding: 56px 24px 40px; }
        .tf-top-grid {
          display: grid;
          grid-template-columns: 1.3fr 1fr 1fr 1fr;
          gap: 40px;
          padding-bottom: 40px;
          border-bottom: 1px solid #343F86;
        }

        /* Brand */
        .tf-logo img { max-width: 130px; height: auto; display: block; margin-bottom: 14px; }
        .tf-tagline { font-size: 12.5px; color: #ffffff; line-height: 1.6; max-width: 240px; margin-bottom: 20px; }
        .tf-socials { display: flex; gap: 8px; }
        .tf-social {
          width: 34px; height: 34px; border-radius: 8px;
          background: #343F86; border: 1px solid #ffffff;
          display: flex; align-items: center; justify-content: center;
          color: #ffffff;
          cursor: pointer; transition: all 0.2s; text-decoration: none;
          flex-shrink: 0;
        }
        .tf-social:hover { background: #262E63; color: #CDD1E0; }

        /* Columns */
        .tf-col-title {
          font-size: 10.5px; font-weight: 700; color: #B0E6F7;
          letter-spacing: 1.8px; text-transform: uppercase; margin-bottom: 18px;
        }
        .tf-col-link {
          display: block; font-size: 12.5px; color: #ffffff;
          text-decoration: none; margin-bottom: 12px; transition: color 0.2s;
        }
        .tf-col-link:hover { color: #fff; }
        .tf-col-more {
          display: inline-block;
          font-size: 11.5px; color: #ffffff; text-decoration: none;
          border-bottom: 1px solid #ffffff; padding-bottom: 1px;
        }
        .tf-col-more:hover { color: #A7ACBD; border-color: #ffffff; }

        /* Contact */
        .tf-contact-label { font-size: 10.5px; color: #ffffff; margin-bottom: 3px; }
        .tf-contact-val {
          font-size: 14px; color: #fff; font-weight: 600;
          margin-bottom: 16px; text-decoration: none; display: block;
          word-break: break-word;
        }
        .tf-contact-val:hover { color: #CDD1E0; }
        .tf-certs { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px; }
        .tf-cert {
          border: 1px solid #262E63; border-radius: 5px;
          padding: 4px 8px; font-size: 9.5px; font-weight: 700;
          color: #ffffff; letter-spacing: 0.4px;
        }

        /* Locations */
        .tf-locations { padding: 24px 0; border-bottom: 1px solid #343F86; }
        .tf-locations-label { font-size: 10.5px; font-weight: 700; color: #B0E6F7; letter-spacing: 1.5px; text-transform: uppercase; margin-bottom: 12px; }
        .tf-locations-list { font-size: 12px; color: #ffffff; line-height: 2; }
        .tf-locations-list a { color: #ffffff; text-decoration: none; }
        .tf-locations-list a:hover { color: #A7ACBD; }
        .tf-loc-sep { color: #262E63; margin: 0 8px; }

        /* Copyright */
        .tf-copy-bar {
          padding: 20px 0 0;
          display: flex; justify-content: space-between; align-items: center;
          flex-wrap: wrap; gap: 10px;
        }
        .tf-copy-text { font-size: 11.5px; color: #ffffff; }
        .tf-copy-links { display: flex; flex-wrap: wrap; gap: 14px 18px; }
        .tf-copy-links a { font-size: 11.5px; color: #ffffff; text-decoration: none; white-space: nowrap; }
        .tf-copy-links a:hover { color: #ffffff; }

        /* ---------- Responsive ---------- */

        /* Tablet */
        @media (max-width: 900px) {
          .tf-main { padding: 48px 20px 32px; }
          .tf-top-grid {
            grid-template-columns: 1fr 1fr;
            gap: 32px 24px;
            row-gap: 36px;
          }
        }

        /* Mobile */
        @media (max-width: 600px) {
          .tf-main { padding: 40px 18px 28px; }
          .tf-top-grid {
            grid-template-columns: 1fr;
            gap: 32px;
            padding-bottom: 32px;
          }

          .tf-logo img { max-width: 110px; margin-bottom: 12px; }
          .tf-tagline { max-width: 100%; font-size: 12px; margin-bottom: 18px; }

          .tf-col-title { margin-bottom: 14px; font-size: 10px; }
          .tf-col-link { font-size: 13px; margin-bottom: 11px; }

          .tf-contact-val { font-size: 15px; }

          .tf-locations { padding: 20px 0;  }
          .tf-locations-list { line-height: 2.2; display:grid}

          .tf-copy-bar {
            flex-direction: column;
            align-items: flex-start;
            gap: 14px;
            padding-top: 24px;
          }
          .tf-copy-links {
            width: 100%;
            gap: 10px 16px;
          }
          .tf-copy-text { font-size: 11px; }
        }

        /* Small phones */
        @media (max-width: 380px) {
          .tf-main { padding: 32px 14px 24px; }
          .tf-tagline { font-size: 11.5px; }
          .tf-contact-val { font-size: 14px; }
          .tf-social { width: 32px; height: 32px; }
        }
      `}</style>

      <footer className="tf-root">
        <div className="tf-main">
          <div className="tf-top-grid">

            {/* Brand */}
            <div>
              <div className="tf-logo">
                <img src={footerlogo} alt="PR Hospital Designers Logo" />
              </div>
              <p className="tf-tagline">
                NABH-compliant hospital infrastructure — design, build, and equip, all under one roof.
              </p>
              <div className="tf-socials">
                {SOCIALS.map((s) => (
                  <a key={s.label} href={s.href} className="tf-social" target="_blank" rel="nofollow noreferrer" title={s.label}>
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Services */}
            <div>
              <div className="tf-col-title">Services</div>
              {SERVICES.map((l) => (
                <Link key={l.label} to={l.path} className="tf-col-link">{l.label}</Link>
              ))}
              <Link to="/our-services" className="tf-col-more">View all services →</Link>
            </div>

            {/* Design Ideas + Company */}
            <div>
              <div className="tf-col-title">Design Ideas</div>
              {DESIGN_IDEAS.map((l) => (
                <Link key={l.label} to={l.path} className="tf-col-link">{l.label}</Link>
              ))}

              <div className="tf-col-title" style={{ marginTop: 24 }}>Company</div>
              {COMPANY.slice(0, 3).map((l) => (
                <Link key={l.label} to={l.path} className="tf-col-link">{l.label}</Link>
              ))}
            </div>

            {/* Contact */}
            <div>
              <div className="tf-col-title">Contact Us</div>
              <div className="tf-contact-label">Call us</div>
              <a href="tel:+919993999840" className="tf-contact-val">+91 99939 99840</a>
              <div className="tf-contact-label">Email us</div>
              <a href="mailto:hospitalsdesigners@gmail.com" className="tf-contact-val" style={{ fontSize: 12.5 }}>hospitalsdesigners@gmail.com</a>
            </div>

          </div>

          {/* Locations */}
          <div className="tf-locations">
            <div className="tf-locations-label">Locations</div>
            <div className="tf-locations-list">
              {LOCATIONS.map((loc, i) => (
                <span key={loc.label}>
                  <Link to={loc.href}>{loc.label}</Link>
                  {i < LOCATIONS.length - 1 && <span className="tf-loc-sep">·</span>}
                </span>
              ))}
            </div>
          </div>

          {/* Copyright */}
          <div className="tf-copy-bar">
            <div className="tf-copy-text">© 2026 PR Hospital Designers Pvt Ltd. All Rights Reserved.</div>
            <div className="tf-copy-links">
              {COMPANY.slice(3).map((l) => (
                <Link key={l.label} to={l.path}>{l.label}</Link>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}